import UIListener from '@/UIListener/UIListener';
import ComponentManager from '@/Management/ComponentManager';
import DetailViewContext from '@/ViewModels/Contexts/DetailViewContext';
import Utilities from '@/Utility/Utilities';
import TextBoxFactory from '@/Factories/ControlFactories/TextBoxFactory';
import {OperationEnableUIListenerParams, OperationEnableUIListenerRule} from '#/DefaultViewExtensionInterfaces';

export default class OperationEnableUIListener extends UIListener {
    private readonly rules: OperationEnableUIListenerRule[];

    constructor(params: OperationEnableUIListenerParams) {
        super();

        this.rules = this.paramOrDefault(params.rules, []);
    }

    /**
     * @override
     */
    public onAfterRefresh(context: DetailViewContext): void {
        if (this.isDetailViewContext(context))
            this.applyRules(context);
    }

    /**
     * @override
     */
    public onDetailViewReady(context: DetailViewContext): void {
        if (this.isDetailViewContext(context))
            this.applyRules(context);
    }

    /**
     * @override
     */
    public onGenericObjectUpdated(context, updatedProperties: Record<string, string>): void {
        this.applyRules(context);
    }

    private applyRules(context: DetailViewContext) {
        const genericObject = context.genericObject;
        for (const rule of this.rules) {
            const operation = rule.operation;
            for (const propertyCondition of rule.conditions) {
                const property = propertyCondition.property;
                const value = genericObject.getValue(property);
                this.applyRule(context, property, value, propertyCondition.isFulfilled, operation);
            }
        }
    }

    private applyRule(context: DetailViewContext, property: string, value: string, isFulfilled: (value: string) => boolean, operation: string) {
        if (Utilities.isNullOrUndefined(value) && !Utilities.isNullOrUndefined(property)) {
            const viewModel = context.getUIFactory<TextBoxFactory>(property)?.viewModel;
            if (viewModel) {
                value = viewModel.value();
            }
        }

        const operationLinkVM = context.toolBar.getElementByMethodName(operation);
        if (!operationLinkVM) {
            return;
        }

        const isOperationEnabled = isFulfilled(value);
        operationLinkVM.isEnabled(isOperationEnabled);
    }
}

ComponentManager.setUIListener('OperationEnableUIListener', OperationEnableUIListener, 'RADPresentation.HTMLClient.DefaultViewExtensions');